// The text a "clock" deck element shows: dd/mm and a 12 hour time in a given
// time zone, like "07/10 11:58:22 am". Shared by the live clock controller and
// the deck editor's canvas, so the two cannot drift. The server renders the
// same shape for the first paint and for an export (DecksHelper#deck_clock_text).
export function clockText(date, { timeZone, showDate = true, showSeconds = true } = {}) {
  const zone = timeZone || undefined
  const time = date.toLocaleTimeString("en-AU", {
    timeZone: zone,
    hour: "numeric",
    minute: "2-digit",
    second: showSeconds ? "2-digit" : undefined,
    hour12: true
  })
  if (!showDate) return time

  const day = date.toLocaleDateString("en-AU", { timeZone: zone, day: "2-digit", month: "2-digit" })
  return `${day} ${time}`
}
